export class CustomParams2006ExtendedFTPReportsModel {
  ReferralTypeID: number;
  CallID: string;
  ColumnSet: string;
}
